var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowBack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.185 11.043a.658.658 0 000 .915l4.737 4.853a.621.621 0 00.893 0 .658.658 0 000-.916l-4.29-4.395 4.29-4.395a.658.658 0 000-.915.621.621 0 00-.893 0l-4.737 4.853z",
    fill: "#333"
  })));
}
export default SvgArrowBack;